import { layoutConstants } from "@constants";

// toggle Menu Mobile
export const toggleMenuMobile = (isOpen) => ({
    type: layoutConstants.TOGGLE_MENU_MOBILE,
    payload: isOpen,
});